import { IAppState } from '../../../AppModulesWrapper';

export const selectIsAreaParts = (state: IAppState): boolean => {
  const { areaParts } = state.servicePickerWidget.offer;

  return Array.isArray(areaParts) && areaParts.length > 0;
};
